import React, { useState } from "react";
import { bool, oneOf } from "prop-types";

import componentSizes from "../../../../constants/componentSizes";
import { passwordCrossedIcon, passwordIcon } from "../../../assets";
import * as S from "./styled";

const PasswordInput = React.forwardRef((props, ref) => {
  const [isVisible, setVisible] = useState(false);
  const toggleVisibility = () => {
    setVisible(!isVisible);
  };

  return (
    <S.Container>
      <S.Input ref={ref} isVisible={isVisible} {...props} />
      <S.ShowPasswordButton onClick={toggleVisibility} type="button">
        <img
          alt={isVisible ? "hide password" : "show password"}
          src={isVisible ? passwordCrossedIcon : passwordIcon}
        />
      </S.ShowPasswordButton>
    </S.Container>
  );
});

PasswordInput.displayName = "PasswordInput";

PasswordInput.propTypes = {
  isValid: bool,
  size: oneOf([componentSizes.SM, componentSizes.MD, componentSizes.LG])
};

PasswordInput.defaultProps = {
  isValid: true,
  size: componentSizes.MD
};

export default PasswordInput;
